import React from 'react';
import styles from './ErrorBanner.module.css';
import Button from './Button';

interface ErrorBannerProps {
  message: string;
  onDismiss?: () => void;
  variant?: 'banner' | 'full-page';
  onRetry?: () => void;
  /** Full-page only: an extra button that leaves the failed page for Today. */
  onBack?: () => void;
  className?: string;
}

export const ErrorBanner: React.FC<ErrorBannerProps> = ({
  message,
  onDismiss,
  variant = 'banner',
  onRetry,
  onBack,
  className,
}) => {
  if (variant === 'full-page') {
    return (
      <div
        className={`${styles.errorFullPage} ${className || ''}`}
        role="alert"
      >
        <div className={styles.errorContent}>
          <p>{message}</p>
          {onRetry && (
            <Button variant="primary" onClick={onRetry}>
              Retry
            </Button>
          )}
          {onBack && (
            <Button variant="outlined" onClick={onBack}>
              Back to Today
            </Button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={`${styles.errorBanner} ${className || ''}`} role="alert">
      <p>{message}</p>
      {onDismiss && (
        <button
          onClick={onDismiss}
          className={styles.dismissButton}
          aria-label="Dismiss error"
        >
          ×
        </button>
      )}
    </div>
  );
};

export default ErrorBanner;
